import React from 'react';
import { RouterProvider } from "react-router-dom";
import { createRoot } from 'react-dom/client';
import './reset.css'
import { router } from './router/routes';
import { DataContextProvider } from './contexts/DataContext';
import { ModalContextProvider } from './contexts/ModalContext';

createRoot(document.getElementById("root")).render(
    <DataContextProvider>
      <ModalContextProvider>
        <RouterProvider router={router} />
      </ModalContextProvider>
    </DataContextProvider>
);


// RouterProvider: provedor para gerenciar rotas, fornece o contexto de roteamento para toda a aplicação